/* eslint-disable react/jsx-props-no-spreading */
// Allowing it here.
import React from 'react';
import { Build } from '@styled-icons/material-outlined/Build';
import { People } from '@styled-icons/material-outlined/People';
import { DirectionsCar } from '@styled-icons/material-outlined/DirectionsCar';
import { CardMembership } from '@styled-icons/material-outlined/CardMembership';
import { LiveHelp } from '@styled-icons/material-outlined/LiveHelp';
import { Menu } from '@styled-icons/material/Menu';
import { ChatBubbleOutline } from '@styled-icons/material-outlined/ChatBubbleOutline';
import { SupportAgent } from '@styled-icons/material-outlined/SupportAgent';
import { PeopleAlt } from '@styled-icons/material-outlined/PeopleAlt';
import { Room } from '@styled-icons/material-outlined/Room';
import { AccountCircle } from '@styled-icons/material-outlined/AccountCircle';
import { ContactMail } from '@styled-icons/material-outlined/ContactMail';
import { FileCopy } from '@styled-icons/material-outlined/FileCopy';
import { Mail } from '@styled-icons/material-outlined/Mail';
import { HomeRepairService } from '@styled-icons/material-outlined/HomeRepairService';
import { Refresh } from '@styled-icons/material-outlined/Refresh';
import { CheckCircle } from '@styled-icons/material-outlined/CheckCircle';
import { PrivacyTip } from '@styled-icons/material-outlined/PrivacyTip';
import { MarkunreadMailbox } from '@styled-icons/material-outlined/MarkunreadMailbox';
import { StarBorderPurple500 } from '@styled-icons/material-outlined/StarBorderPurple500';
import { Feedback } from '@styled-icons/material-outlined/Feedback';
import { Gavel } from '@styled-icons/material-outlined/Gavel';
import { Money } from '@styled-icons/material-outlined/Money';
import { FavoriteBorder } from '@styled-icons/material-outlined/FavoriteBorder';
import { Fingerprint } from '@styled-icons/material-outlined/Fingerprint';
import { ThumbUp } from '@styled-icons/material-outlined/ThumbUp';
import { Receipt } from '@styled-icons/material-outlined/Receipt';
import { AccountBox } from '@styled-icons/material-outlined/AccountBox';
import { BookmarkBorder } from '@styled-icons/material-outlined/BookmarkBorder';
import { Analytics } from '@styled-icons/material-outlined/Analytics';
import { CarRepair } from '@styled-icons/material-outlined/CarRepair';
import { PedalBike } from '@styled-icons/material-outlined/PedalBike';
import { ElectricCar } from '@styled-icons/material-outlined/ElectricCar';
import { CarCrash } from '@styled-icons/material-outlined/CarCrash';
import { PinDrop } from '@styled-icons/material-outlined/PinDrop';
import { Map } from '@styled-icons/material-outlined/Map';
import { TwoWheeler } from '@styled-icons/material-outlined/TwoWheeler';

interface MobileMenuIconProps {
  name?: string;
}

const sizeProps = { height: 24, width: 24 };
const icons: Record<string, React.ReactElement> = {
  BuildOutlinedIcon: <Build {...sizeProps} style={{ transform: 'scaleX(-1)' }} aria-hidden />,
  PeopleIcon: <People {...sizeProps} aria-hidden />,
  DirectionsCarOutlinedIcon: <DirectionsCar {...sizeProps} aria-hidden />,
  CardMembershipIcon: <CardMembership {...sizeProps} aria-hidden />,
  LiveHelpIcon: <LiveHelp {...sizeProps} aria-hidden />,
  ChatBubbleOutlineIcon: <ChatBubbleOutline {...sizeProps} aria-hidden />,
  SupportAgentIcon: <SupportAgent {...sizeProps} aria-hidden />,
  PeopleAltOutlinedIcon: <PeopleAlt {...sizeProps} aria-hidden />,
  MailOutlinedIcon: <Mail {...sizeProps} />,
  ContactMailOutlinedIcon: <ContactMail {...sizeProps} />,
  RoomOutlinedIcon: <Room {...sizeProps} />,
  AccountCircleOutlinedIcon: <AccountCircle {...sizeProps} />,
  FileCopyOutlinedIcon: <FileCopy {...sizeProps} />,
  HomeRepairServiceOutlinedIcon: <HomeRepairService {...sizeProps} />,
  RefreshOutlinedIcon: <Refresh {...sizeProps} />,
  CheckCircleOutlineOutlinedIcon: <CheckCircle {...sizeProps} />,
  PrivacyTipIcon: <PrivacyTip {...sizeProps} />,
  MarkunreadMailboxIcon: <MarkunreadMailbox {...sizeProps} />,
  StarBorderPurple500Icon: <StarBorderPurple500 {...sizeProps} />,
  BuildIcon: <Build {...sizeProps} />,
  GavelIcon: <Gavel {...sizeProps} />,
  FeedbackIcon: <Feedback {...sizeProps} />,
  MoneyIcon: <Money {...sizeProps} />,
  FavoriteBorderIcon: <FavoriteBorder {...sizeProps} />,
  FingerprintIcon: <Fingerprint {...sizeProps} />,
  ThumbUpIcon: <ThumbUp {...sizeProps} />,
  ReceiptIcon: <Receipt {...sizeProps} />,
  AccountBoxIcon: <AccountBox {...sizeProps} />,
  BookmarkBorderIcon: <BookmarkBorder {...sizeProps} />,
  AnalyticsIcon: <Analytics {...sizeProps} />,
  CarRepairIcon: <CarRepair {...sizeProps} />,
  PedalBikeIcon: <PedalBike {...sizeProps} />,
  ElectricCarIcon: <ElectricCar {...sizeProps} />,
  CarCrashIcon: <CarCrash {...sizeProps} />,
  PinDropIcon: <PinDrop {...sizeProps} />,
  MapIcon: <Map {...sizeProps} />,
  TwoWheelerIcon: <TwoWheeler {...sizeProps} />,
};

export const MobileMenuIcon = ({ name }: MobileMenuIconProps) => {
  if (!name) return <Menu size={24} aria-hidden />;

  return icons[name] ?? <Menu size={24} aria-hidden />;
};
